import React from 'react'
import Block from '../../adapters/helpers/Block'
export default function ArticleWrapper(props) {
    return (
        <div className='article-main-wrap'>
            <div>
                {props?.document?.fields?.aricleDataWrapper
                    .filter((val, index) => index == 0)
                    .map((res) => {
                        return new Block(res).renderBlockFromDocument({
                            extraAttributes: props.extraAttributes,
                        })
                    })}
            </div>

            <div className='lower-article-body'>
                <div className='leftbigSection'>
                    {props.document.fields.aricleDataWrapper
                        .filter((val, index) => val.fields.contentType !== 'additionalReadingBlock' && index != 0 && index !== props.document.fields.aricleDataWrapper.length - 1)
                        .map((res) => {
                            return new Block(res).renderBlockFromDocument({
                                extraAttributes: props.extraAttributes,
                            })
                        })}
                </div>
                <div className='rightsmallsection'>
                    {props.document.fields.aricleDataWrapper
                        .filter((val, index) => val.fields.contentType == 'additionalReadingBlock' || index == props.document.fields.aricleDataWrapper.length - 1)
                        .map((res) => {
                            return new Block(res).renderBlockFromDocument({
                                extraAttributes: props.extraAttributes,
                            })
                        })}
                </div>
            </div>
        </div>
    )
}
